var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.9111 16.0906C23.9111 15.7325 23.7009 15.4334 23.4018 15.2853L23.4252 8.78038C23.493 8.75469 23.5352 8.69048 23.5344 8.61872C23.5344 8.54696 23.4877 8.4835 23.4221 8.46008L11.8992 3.08206C11.7531 3.02994 11.5934 3.02994 11.4465 3.08206L0.112768 8.46084C0.0457199 8.48426 0.000518963 8.54771 -0.000234386 8.61948C-0.000987735 8.69124 0.0419532 8.75545 0.108248 8.78113L11.5853 14.4248C11.7443 14.486 11.9198 14.486 12.0788 14.4248L22.6372 9.08632L22.6138 15.2845C22.3155 15.4318 22.1053 15.7333 22.1053 16.089C22.1053 16.4607 22.3313 16.7833 22.6545 16.9215C22.3313 17.5613 22.1053 18.8742 22.1053 19.2489C22.1053 19.7482 22.5098 20.1531 23.0078 20.1531C23.505 20.1531 23.9096 19.7482 23.9096 19.2489C23.9096 18.8742 23.6828 17.5613 23.3604 16.9215C23.6843 16.7848 23.9111 16.4622 23.9111 16.0906Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.7312 11.4014C3.73196 12.6825 3.73259 17.1663 3.73259 17.4058C3.73259 19.7914 7.32303 21.7335 11.8381 21.8551C16.3524 21.7335 19.9428 19.7936 19.9428 17.4058C19.9428 17.1679 19.943 12.6833 19.9445 11.4014L12.0837 15.3027C11.9243 15.3646 11.7483 15.3646 11.5889 15.3027L3.7312 11.4014Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.625)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHat);
export default __webpack_public_path__ + "static/media/hat.78023190.svg";
export { ForwardRef as ReactComponent };